import { render, staticRenderFns } from "./ppcNormal.vue?vue&type=template&id=63e1945e"
import script from "./ppcNormal.vue?vue&type=script&lang=js"
export * from "./ppcNormal.vue?vue&type=script&lang=js"
import style0 from "./ppcNormal.vue?vue&type=style&index=0&id=63e1945e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports